<template>
  <div id="centerRight2">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <span class="fs-xl text mx-2">残疾人就业类别分布</span>
      </div>
      <div class="d-flex ai-center flex-column body-box">
        <dv-capsule-chart class="dv-cap-chart" :config="config" />
        <!-- <centerRight2Chart1 /> -->
      </div>
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <span class="fs-xl text mx-2">残疾人平均就业率</span>
      </div>
      <div class="d-flex ai-center flex-column body-box">
        <div class="water">
          <dv-water-level-pond class="dv-wa-le-po" :config="water" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import centerRight2Chart1 from '@/components/echart/centerRight/centerRightChart'

export default {
  data() {
    return {
      water: {
        data: [54, 88],
        shape: "roundRect",
        formatter: "{value}%",
        waveNum: 3,
      },
      config: {
        data: [
          {
            name: "多重",
            value: 290,
          },
          {
            name: "言语",
            value: 56,
          },
          {
            name: "精神",
            value: 186,
          },
          {
            name: "听力",
            value: 453,
          },
          {
            name: "视力",
            value: 724,
          },
          {
            name: "智力",
            value: 1000,
          },
          {
            name: "肢体",
            value: 2990,
          },
        ],
      },
    }
  },
  // components: { centerRight2Chart1 }
}
</script>

<style lang="scss" scoped>
.water {
  width: 100%;
  .dv-wa-le-po {
    height: 10.6rem;
  }
}
#centerRight2 {
  $box-height: 430px;
  $box-width: 300px;
  padding: 5px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    padding: 5px;
    height: $box-height;
    width: $box-width;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-cap-chart {
      width: 100%;
      height: 160px;
    }
  }
}
</style>
